import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatButton, MatCheckbox, MatDialogRef, MatSelectChange, MatSlideToggleChange, MatVerticalStepper } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/libraries/globals';
import { ClientesContactosService } from 'src/app/services/clientesContactos/clientesContactos.service';
import { InputPredictiveService } from 'src/app/services/components/inputPredictive.service';
import { CotizacionesService } from 'src/app/services/cotizaciones/cotizaciones.service';
import { EmpresasVendedoresService } from 'src/app/services/empresasVendedores/empresasVendedores.service';
import { Dialogs } from 'src/app/ui/dialogs/dialogs';
import { Wait } from 'src/app/ui/wait/Wait';

@Component({
  selector: 'comp-cotizaciones-index-duplicar',
  templateUrl: './duplicar.component.html',
  styleUrls: ['./duplicar.component.css']
})
export class CotizacionesIndexDuplicarComponent implements OnInit, AfterViewInit {

  @ViewChild('mainContainer', {static:false}) mainContainer : ElementRef;
  @ViewChild('btnGuardar', {static:false})    btnGuardar    : MatButton;
  @ViewChild('btnCerrar', {static:false})     btnCerrar     : MatButton;
  @ViewChild('ngForm', {static: false})       ngFormGeneral : FormGroupDirective;
  @ViewChild('stepper', {static: false})      stepper       : MatVerticalStepper;
  
  @ViewChildren('chkCondicion') chkCondicion : QueryList<MatCheckbox>;

  @Output('onChange') onChange : EventEmitter<any> = new EventEmitter<any>();
  
  private boolGuardar : boolean = false;
  private objDialogs  : Dialogs = new Dialogs();
  private form        : FormGroup;

  private lstEmpresas                     : Array<any> = [];
  private lstClientes                     : Array<any> = [];
  private lstClientesContactos            : Array<any> = [];
  private lstServiciosTipos               : Array<any> = [];
  private lstEstados                      : Array<any> = [];
  private lstFormasPagos                  : Array<any> = [];
  private lstMetodosPagos                 : Array<any> = [];
  private lstEmpresasVendedores           : Array<any> = [];
  private lstCotizacionesCondicionesTipos : Array<any> = [];

  public objData : any = null;

  // PREDICTIVE CLIENTE
  private idCliente : number = 0;

  // VARIABLES PRECIOS
  iva : any = 0.16;

  lstPartidas : Array<any> = []
  lstValid    : Array<boolean> = []

  constructor(private objDialogRef : MatDialogRef<CotizacionesIndexDuplicarComponent>, 
              private objCotizacionesService : CotizacionesService,
              private objEmpresasVendedoresService : EmpresasVendedoresService,
              private objClientesContactosService : ClientesContactosService,
              private objInputPredictiveService : InputPredictiveService,
              private toastr: ToastrService) { }

  ngOnInit() {
    
    this.form = new FormGroup({
      'hasCliente'          : new FormControl(false),
      'cliente'             : new FormControl(null, [Validators.required]),
      'clienteContacto'     : new FormControl(null),
      'empresa'             : new FormControl(null, [Validators.required]),
      'empresaVendedor'     : new FormControl(null, [Validators.required]),
      'vigencia'            : new FormControl(null, [Validators.required]),
      'formaPago'           : new FormControl(null, [Validators.required]),
      'metodoPago'          : new FormControl(null, [Validators.required]),
      'plazo'               : new FormControl(null),
      'terminosCondiciones' : new FormControl(null),
    });

  }

  ngAfterViewInit() {
    this.edit();
  }

  // EVENTOS
  close()
  {
    if(!this.boolGuardar)
    {
      this.objDialogRef.close();
    }
  }

  sltHasCliente_changeEvent(event : MatSlideToggleChange) {
    this.idCliente = 0;
    this.lstClientes = [];
    this.lstClientesContactos = [];

    this.form.controls["cliente"].setValue("");
    this.form.controls["clienteContacto"].setValue("");

    if(event.checked) {
      this.form.controls["cliente"].disable();
      this.form.controls["clienteContacto"].disable();
    } else {
      this.form.controls["cliente"].enable();
      this.form.controls["clienteContacto"].enable();
    }
  }

  btnAddPartida_clickEvent() {
    this.lstPartidas.push({idServicioTipo : 0, clave : "", descripcion : "", precioUnitario : "", cantidad : "", total : 0});
    this.lstValid.push(true);
  }

  btnRemovePartida_clickEvent(index : number) {
    this.lstPartidas.splice(index, 1);
    this.lstValid.splice(index, 1);
  }

  selectedEmpresa_selectedEvent(event : MatSelectChange) {

    this.form.controls["empresaVendedor"].setValue("");
    this.lstEmpresasVendedores  = [];

    if(!Globals.validValue(event.value))
    {
      return;
    }

    this.getEmpresasVendedores(event.value);

  }

  btnGuardar_clickEvent()
  {

    if(this.form.invalid) {
      this.toastr.warning('Datos incompletos en el formulario', 'Mensaje', { timeOut: 2000 });
      this.ngFormGeneral.onSubmit(undefined);
      this.stepper.selectedIndex = 0;
      return;
    }

    if(this.lstPartidas.length == 0) {
      this.toastr.warning('No se ha agregado ninguna partida', 'Mensaje', { timeOut: 2000 });
      this.stepper.selectedIndex = 1;
      return;
    }

    if(!this.validatePartidas()) {
      this.toastr.warning('Algunas partidas tienen formulario incompleto', 'Mensaje', { timeOut: 2000 });
      this.stepper.selectedIndex = 1;
      return;
    }

    if(this.chkCondicion.filter(x => x.checked).length == 0) {
      this.toastr.warning('Seleccione al menos una condición de venta', 'Mensaje', { timeOut: 2000 });
      this.stepper.selectedIndex = 2;
      return;
    }

    this.store();

  }

  // PREDICTIVE CLIENTE
  txtCliente_keyup(value : string, event : KeyboardEvent) {

    if(event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      return;
    }

    var txtSearch     = value;
  
    this.lstClientes = [];

    if(!Globals.validStringValue(txtSearch)) {
      return;
    }

    let lstSearchFilters : Array<any> = [];

    lstSearchFilters.push({field : 'Codigo' });
    lstSearchFilters.push({field : 'Name' });
    lstSearchFilters.push({field : 'RazonSocial' });
    lstSearchFilters.push({field : 'RFC' });
    lstSearchFilters.push({field : 'Telefono' });
    lstSearchFilters.push({field : 'Celular' });
    lstSearchFilters.push({field : 'Email' });
    lstSearchFilters.push({field : 'Direccion' });
    lstSearchFilters.push({field : 'Ciudad' });
    lstSearchFilters.push({field : 'CodigoPostal' });
    

    let varArgs  : any = {
      search            : txtSearch,
      searchFilters     : lstSearchFilters,
      filters           : {},
      columns           : {},
      dateFilters       : { dateStart : '2017-01-01', dateEnd : '2018-12-31'}
    };
    
    this.objInputPredictiveService.predictive("Clientes/Predictive", varArgs)
    .subscribe( objResponse => {
      
      if(objResponse.session) {
      
        if(objResponse.action) {

          this.lstClientes = [];

          var lstClientes : Array<any> = objResponse.result.rows;

          if(lstClientes.length > 0) {
            objResponse.result.rows.forEach(item => {
              this.lstClientes.push({ idCliente : item.idCliente, name : item.razonSocial });
            });
          } else {
            this.lstClientes.push({idCliente : 0, name : "No se encontraron resultados..."});
          }

        } else {
          this.lstClientes.push({idCliente : 0, name : objResponse.message});
        }
      } else {
        this.lstClientes.push({idCliente : 0, name : objResponse.message});
      }
      
    }, error => {

      this.lstClientes = [];

      if( error.status == 401) {
        this.lstClientes.push({idCliente : 0, name : "La sesión ha finalizado por inactividad."});
      } else {
        this.lstClientes.push({idCliente : 0, name : "Ocurrio un error inesperado. Póngase en contacto con el administrador."});
      }

    });

  }

  selectedCliente_selectedEvent(event : any) {
    this.idCliente = event.option.id.idCliente;

    if(this.idCliente != 0) {
      this.getClientesContactos(this.idCliente);
    }
  }

  txtCliente_clickEvent() {
    this.idCliente    = 0;
    this.lstClientes  = [];
    this.lstClientesContactos = []
    this.form.controls["cliente"].setValue("");
    this.form.controls["clienteContacto"].setValue("");
  }

  focusOutCliente_function() {
    if(this.idCliente == 0)
    {
      this.form.controls["cliente"].setValue("");
      this.form.controls["clienteContacto"].setValue("");
    }
  }

  // PREDICTIVE SERVICIO TIPO
  txtServicioTipo_keyup(value : string, event : KeyboardEvent, index) {

    if(event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      return;
    }

    this.lstValid[index] = true;

    var txtSearch     = value;
  
    this.lstServiciosTipos = [];

    if(!Globals.validStringValue(txtSearch)) {
      return;
    }

    let lstSearchFilters : Array<any> = [];

    lstSearchFilters.push({field : 'Clave' });
    lstSearchFilters.push({field : 'Name' });
    lstSearchFilters.push({field : 'Descripcion' });
    

    let varArgs  : any = {
      search            : txtSearch,
      searchFilters     : lstSearchFilters,
      filters           : {},
      columns           : {},
      dateFilters       : { dateStart : '2017-01-01', dateEnd : '2018-12-31'}
    };
    
    this.objInputPredictiveService.predictive("Servicios/Tipos/Predictive", varArgs)
    .subscribe( objResponse => {
      
      this.lstServiciosTipos = [];
      
      if(objResponse.session) {
      
        if(objResponse.action) {

          var arrServiciosTipos : Array<any> = objResponse.result.rows;
          if(arrServiciosTipos.length > 0) {

            objResponse.result.rows.forEach(item => {
              this.lstServiciosTipos.push({ idServicioTipo : item.idServicioTipo, hasTrouble : false, clave : item.clave, name : item.name, descripcion : item.descripcion, precioUnitario : item.precioUnitario });
            });

          } else {
            this.lstServiciosTipos.push({ idServicioTipo : 0, hasTrouble : true, clave : "000", descripcion: "No se encontraron resultados..." });
          }

        } else {
          this.lstServiciosTipos.push({ idServicioTipo : 0,hasTrouble : true, clave : "000", descripcion: objResponse.message });
        }
      } else {
        this.lstServiciosTipos.push({ idServicioTipo : 0, hasTrouble : true, clave : "000", descripcion: objResponse.message });
      }
      
    }, error => {

      this.lstServiciosTipos = [];

      if( error.status == 401) {
        this.lstServiciosTipos.push({ idServicioTipo : 0, hasTrouble : true, clave : "000", descripcion: "La sesión ha finalizado por inactividad." });
      } else {
        this.lstServiciosTipos.push({ idServicioTipo : 0, hasTrouble : true, clave : "000", descripcion: "Ocurrio un error inesperado. Póngase en contacto con el administrador." });
      }

    });

  }

  selectedServicioTipo_selectedEvent(event : any, index : number) {
    this.lstPartidas[index].idServicioTipo  = event.option.id.idServicioTipo;
    this.lstPartidas[index].descripcion     = event.option.id.descripcion;
    this.lstPartidas[index].precioUnitario  = event.option.id.precioUnitario;
    this.lstServiciosTipos = [];
  }

  txtServicioTipo_clickEvent(index : number) {
    this.lstServiciosTipos                  = [];
    this.lstPartidas[index].idServicioTipo  = 0;
    this.lstPartidas[index].clave           = "";
    this.lstPartidas[index].descripcion     = "";
    this.lstPartidas[index].precioUnitario  = 0;
  }

  focusOutServicioTipo_function(index : number) {
    if(this.lstPartidas[index].idServicioTipo == 0)
    {
      this.lstPartidas[index].clave           = "";
      this.lstPartidas[index].descripcion     = "";
      this.lstPartidas[index].precioUnitario  = 0;
    }
  }

  // METODOS
  private getTotalItem(index : number) : any {
    var objPartida = this.lstPartidas[index];

    objPartida.total = objPartida.precioUnitario * objPartida.cantidad;

    return objPartida.total;
  }

  private getSubtotal() : any {
    return this.lstPartidas.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  private getTotalIva() : any {
    let total     = this.lstPartidas.map(t => t.total).reduce((acc, value) => acc + value, 0);
    let totalIva  = total * (this.iva / 100);
    return totalIva;
  }

  private getTotal() : any {
    let subtotal  = this.getSubtotal();
    let totalIva  = this.getTotalIva();
    return subtotal + totalIva;
  }

  private validatePartidas() : boolean {
    let valid : boolean = true;

    this.lstPartidas.forEach((item, index) => {
      this.lstValid[index] = true;

      if(item.idServicioTipo == 0)
      {
        valid = false;
        this.lstValid[index] = false;
      }
    });

    return valid;
  }

  private getEmpresasVendedores(idEmpresa : number, firstLoad : boolean = false, idEmpresaVendedor : number = 0) : void {
    
    this.form.controls["empresaVendedor"].disable();

    let objEmpresaVendedor : any =
    {
      idEmpresa : idEmpresa
    };

    this.objEmpresasVendedoresService.listByIdEmpresa(objEmpresaVendedor)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.lstEmpresasVendedores = objResponse.result.empresasVendedores;

          if(firstLoad) {
            var objEmpresaVendedor = this.lstEmpresasVendedores.find(x => x.idEmpresaVendedor == idEmpresaVendedor);

            if(Globals.validValue(objEmpresaVendedor)) {
              this.form.controls["empresaVendedor"].setValue(idEmpresaVendedor);
            }
          }
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.form.controls["empresaVendedor"].enable();

    }, error => {

      this.form.controls["empresaVendedor"].enable();

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
  }

  private getClientesContactos(idCliente : number, firstLoad : boolean = false, idClienteContacto : number = 0) : void {
    
    this.form.controls["clienteContacto"].disable();

    let objClienteContacto : any =
    {
      idCliente : idCliente
    };

    this.objClientesContactosService.listByIdCliente(objClienteContacto)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.lstClientesContactos = objResponse.result.clientesContactos;

          if(firstLoad) {
            var objClienteContacto = this.lstClientesContactos.find(x => x.idClienteContacto == idClienteContacto);

            if(Globals.validValue(objClienteContacto)) {
              this.form.controls["clienteContacto"].setValue(idClienteContacto);
            }
          }
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.form.controls["clienteContacto"].enable();

    }, error => {

      this.form.controls["clienteContacto"].enable();

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
  }

  private loading(value : boolean) {
    if(value) {

      Wait.show(this.mainContainer, "Guardando...");
      this.btnGuardar.disabled        = true;
      this.btnCerrar.disabled         = true;
      this.boolGuardar                = true;
      this.objDialogRef.disableClose  = true;

    } else{

      Wait.hide(this.mainContainer);
      this.btnGuardar.disabled        = false;
      this.btnCerrar.disabled         = false;
      this.boolGuardar                = false;
      this.objDialogRef.disableClose  = false;

    }
  }

  private edit() : void {

    Wait.show(this.mainContainer, "Espere por favor...");

    let objCotizacionEdit : any =
    {
      idCotizacion : this.objData.idCotizacion
    };

    this.objCotizacionesService.edit(objCotizacionEdit)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.lstEmpresas                      = objResponse.result.empresas;
          this.lstFormasPagos                   = objResponse.result.formasPagos;
          this.lstMetodosPagos                  = objResponse.result.metodosPagos;
          this.lstCotizacionesCondicionesTipos  = objResponse.result.cotizacionesCondicionesTipos;
          this.iva                              = objResponse.result.porcentajeIva;

          var objCotizacion     = objResponse.result.cotizacion;

          this.form.controls["hasCliente"].setValue(!objCotizacion.hasCliente);

          if(objCotizacion.hasCliente)
          {
            this.idCliente = objCotizacion.idCliente;
            this.form.controls["cliente"].setValue(objCotizacion.cliente);

            var idClienteContacto = objCotizacion.idClienteContacto;

            if(idClienteContacto != 0) {
              this.getClientesContactos(this.idCliente, true, idClienteContacto);
            }
          } else {
            this.form.controls["cliente"].disable();
            this.form.controls["clienteContacto"].disable();
          }

          var objEmpresa = this.lstEmpresas.find(x => x.idEmpresa == objCotizacion.idEmpresa);

          if(Globals.validValue(objEmpresa)) {
            this.form.controls["empresa"].setValue(objCotizacion.idEmpresa);
          }

          this.form.controls["vigencia"].setValue(objCotizacion.vigencia);

          var objFormaPago = this.lstFormasPagos.find(x => x.idFormaPago == objCotizacion.idFormaPago);

          if(Globals.validValue(objFormaPago)) {
            this.form.controls["formaPago"].setValue(objCotizacion.idFormaPago);
          }

          var objMetodoPago = this.lstMetodosPagos.find(x => x.idMetodoPago == objCotizacion.idMetodoPago);

          if(Globals.validValue(objMetodoPago)) {
            this.form.controls["metodoPago"].setValue(objCotizacion.idMetodoPago);
          }

          this.form.controls["plazo"].setValue(objCotizacion.plazo);

          this.getEmpresasVendedores(objCotizacion.idEmpresa, true, objCotizacion.idEmpresaVendedor);

          this.form.controls["terminosCondiciones"].setValue(objCotizacion.terminosCondiciones);

          var lstCotizacionesPartidas : Array<any> = objResponse.result.cotizacionesPartidas;

          lstCotizacionesPartidas.forEach(item => {
            this.lstPartidas.push({idServicioTipo : item.idServicioTipo, clave : item.clave, descripcion : item.descripcion, precioUnitario : item.precioUnitario, cantidad : item.cantidad, total : item.total });
            this.lstValid.push(true);
          });

          this.iva = objCotizacion.iva;
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      Wait.hide(this.mainContainer);

    }, error => {

      Wait.hide(this.mainContainer);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

  private store() : void {

    this.loading(true);

    let lstCotizacionesCondiciones : Array<any> = this.chkCondicion.filter(x => x.checked).map(x => x.value);

    let objCotizacionStore : any =
    {
      hasCliente              : this.form.controls["hasCliente"].value, 
      idCliente               : this.idCliente,
      idClienteContacto       : this.form.controls["clienteContacto"].value,
      idEmpresa               : this.form.controls["empresa"].value,
      idEmpresaVendedor       : this.form.controls["empresaVendedor"].value,
      vigencia                : this.form.controls["vigencia"].value,
      idFormaPago             : this.form.controls["formaPago"].value,
      idMetodoPago            : this.form.controls["metodoPago"].value,
      plazo                   : this.form.controls["plazo"].value,
      terminosCondiciones     : this.form.controls["terminosCondiciones"].value,
      subtotal                : this.getSubtotal(),
      iva                     : this.iva,
      totalIva                : this.getTotalIva(),
      total                   : this.getTotal(),
      cotizacionesCondiciones : lstCotizacionesCondiciones,
      partidas                : this.lstPartidas
    };

    this.objCotizacionesService.store(objCotizacionStore)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.onChange.emit(this);
          this.objDialogRef.close();
          this.objDialogs.Success(objResponse.title, objResponse.message);

          let url =  "api/Cotizaciones/File/Cotizacion/" + objResponse.result.idCotizacion;
          window.open(url.toString(), '_blank');
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.loading(false);

    }, error => {

      this.loading(false);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

}
